/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Mod7_LinkInputs */

const es_landing_mod7_link = /** @type {(inputs: Landing_Mod7_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para armadores`)
};

const gl_landing_mod7_link = /** @type {(inputs: Landing_Mod7_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para armadores`)
};

const en_landing_mod7_link = /** @type {(inputs: Landing_Mod7_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For boat owners`)
};

/**
* | output |
* | --- |
* | "For boat owners" |
*
* @param {Landing_Mod7_LinkInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_mod7_link = /** @type {((inputs?: Landing_Mod7_LinkInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Mod7_LinkInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_mod7_link(inputs)
	if (locale === "en") return en_landing_mod7_link(inputs)
	return es_landing_mod7_link(inputs)
});